import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../../shared/components/icon/icon.component';

/**
 * Wizard step progress — a compact segment bar on mobile, a clickable left
 * rail with done/current/upcoming state on desktop/tablet. One responsive
 * component (see BreakpointService); both markup blocks always render, CSS
 * shows/hides by breakpoint rather than branching in the template.
 */
@Component({
  selector: 'app-lead-wizard-step-indicator',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './lead-wizard-step-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lead-wizard-step-indicator.component.css',
})
export class LeadWizardStepIndicatorComponent {
  @Input() steps: string[] = [];
  @Input() currentStep = 0;
  @Output() stepSelected = new EventEmitter<number>();
}
